import { Component, OnInit } from '@angular/core';
import { DetailPlanModel } from '../../models/plan-detail.model';
import { ResponsibleService } from '../../services/responsible.service';
import { InputSelectModel } from '../input-select/inputSelect.model';
import { DependentMeepServerModel } from '../../models/dependent.model';
import { NotificationService } from '../../notification/swal/notification.service';
import { DependentService } from '../../services/dependent.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SignUpSignatureModel } from '../../models/signUpSignature.model';
import { PlanService } from '../../services/plan.service';
import { Form } from '../../services/form';


@Component({
  selector: 'app-plan-detail',
  templateUrl: './plan-detail.component.html',
  styleUrls: ['./plan-detail.component.less']
})
export class PlanDetailComponent extends Form implements OnInit {
  [x: string]: any;

  planDetail: DetailPlanModel = new DetailPlanModel();

  hasPaymentMethods = true;
  paymentMethods: InputSelectModel[] = new Array<InputSelectModel>();
  selectedPaymentMethod = '0';

  dependents: InputSelectModel[] = new Array<InputSelectModel>();
  hasDependents = true;
  selectedBeneficiado = '0';

  cvv;

  routeParams: Params;

  // tslint:disable-next-line:max-line-length
  constructor(private planService: PlanService,
              private responsibleService: ResponsibleService,
              private notificationService: NotificationService,
              private dependentService: DependentService,
              private route: ActivatedRoute,
              private router: Router) {

    super();
    this.route.params.subscribe((params: Params) => {
      this.routeParams = params;
    });
  }

  ngOnInit() {
    this.planService.getDetail(this.routeParams.planId)
    .then((_planDetail) => {
        if (_planDetail == null) {
          return;
        }

        this.planDetail = _planDetail;

        this.getPaymentMethods();
        this.getDependents(this.planDetail.EstabelecimentoId);
      });
  }

  private getPaymentMethods() {
    this.responsibleService.getCreditCards()
      .then((_creditCards) => {
        if (_creditCards.length === 0) {
          this.hasPaymentMethods = false;
        }
        _creditCards.forEach((creditCard) => {
          this.paymentMethods.push({ title: `**** **** **** ${creditCard.finalNumero}`, value: creditCard.id });
        });
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

  private getDependents(localId: string) {
    this.dependentService.getByLocal(localId)
      .then((_dependents) => {
        if (_dependents.length === 0) {
          this.hasDependents = false;
        }
        _dependents.forEach((dependent) => {
          this.dependents.push({ title: dependent.NomeTitular, value: dependent.HistoricoAssociacaoId });
        });
      })
      .catch((err) => {
        this.notificationService.showErrorNotification(err.message);
      });
  }

    contract() {
      if (!this.routeParams.planId ||
          !this.selectedBeneficiado ||
          !this.selectedPaymentMethod ||
          !this.cvv) {

          this.notificationService.showErrorNotification('Favor preencher todos os campos!');
          return;
      }

      const assinarModel: SignUpSignatureModel = {
        PlanoEscolhidoId: this.routeParams.planId,
        BeneficiadoId: this.selectedBeneficiado,
        CartaoParaPagamentoId: this.selectedPaymentMethod,
        CodigoSeguranca: this.cvv
      };
      this.planService.signUp(assinarModel)
        .then(() => {
          this.notificationService.showSuccessNotification('Plano contratado com sucesso!')
            .then(() => {
              this.router.navigate([`general/currentSubscription`]);
            });
        })
        .catch((err) => this.notificationService.showErrorNotification(err.message ? err.message : err.errors[0].messages[0]));
    }

}




// WEBPACK FOOTER //
// /usr/src/app/src/app/components/plan-detail/plan-detail.component.ts